window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of browser and user agent related functions.
 *
 * @return {Object} Public methods of o_util.browser.
 */
o_util.browser = (function() {
    "use strict";

    var uaString = window.navigator.userAgent.toLowerCase();

    /**
     * Checks if the current browser is the Internet Explorer 8.
     *
     * @deprecated Due to unsupported-browser checks - we dont have IE8 anymore
     *
     * @example
     * if (o_util.browser.isIE8()) {
     *      // Just do this in IE8
     * } else {
     *      ...
     * }
     *
     * @return {Boolean} true, if the browser is the IE8.
     */
    function isIE8() {
        o_global.debug.warn("o_util.browser.isIE8 is deprecated - IE8 is doomed.");
        return navigator.userAgent.indexOf("MSIE 8") > -1;
    }

    /**
     * Returns the current value of the style for an element or an empty string.
     *
     * @deprecated Use native window.getComputedStyle(elem, null).getPropertyValue(styleProp) instead.
     *
     * @example o_util.browser.getStyle(document.body, "padding-top"); // => e.g. "0px"
     *
     * @param {Object} elem         Element.
     * @param {String} styleProp    Style you want the value of.
     *
     * @return {String} Style value.
     */
    function getStyle(elem, styleProp) {
        o_global.debug.warn("o_util.browser.getStyle is deprecated, use native getComputedStyle instead");
        return window.getComputedStyle(elem, null).getPropertyValue(styleProp);
    }

    /**
     * Returns the width of the scrollbar.
     *
     * @example o_util.browser.getScrollbarWidth(); // => e.g. 17
     *
     * @return {Number} The actual width of the scrollbar.
     */
    function getScrollbarWidth() {
        var scrollDiv = document.createElement("div"),
            scrollbarWidth = 0;

        if (document.body.clientWidth < window.innerWidth) {
            scrollDiv.className = "p_scrollbarMeasure";
            document.body.appendChild(scrollDiv);
            scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }

        return scrollbarWidth;
    }

    /**
     * Finds the string "needle" in user agent string.
     *
     * @param {String} needle   String to find in haystack.
     *
     * @return {Boolean} Was needle found in ua-string?
     */
    function findInUserAgent(needle) {
        return uaString.indexOf(needle) !== -1;
    }

    /**
     * Return public API.
     */
    return {
        "isIE8": isIE8,
        "getStyle": getStyle,
        "getScrollbarWidth": getScrollbarWidth,
        "findInUserAgent": findInUserAgent
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.getScrollbarWidth = o_util.browser.getScrollbarWidth;
o_global.helper.getStyle = o_util.browser.getStyle;
o_global.helper.isIE8 = o_util.browser.isIE8;
